import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "my-4"
}
const _hoisted_2 = { class: "radio-group-wrapper" }
const _hoisted_3 = { class: "radio-group-label" }
const _hoisted_4 = { class: "radio-group-wrapper" }
const _hoisted_5 = { class: "radio-group-label" }
const _hoisted_6 = { class: "radio-group-wrapper" }
const _hoisted_7 = { class: "radio-group-label" }
const _hoisted_8 = { class: "radio-group-wrapper" }
const _hoisted_9 = { class: "radio-group-label" }
const _hoisted_10 = { class: "radio-group-wrapper" }
const _hoisted_11 = { class: "radio-group-label" }
const _hoisted_12 = { class: "radio-group-wrapper" }
const _hoisted_13 = { class: "radio-group-label" }
const _hoisted_14 = { class: "radio-group-wrapper" }
const _hoisted_15 = { class: "radio-group-label" }
const _hoisted_16 = { class: "radio-group-wrapper" }
const _hoisted_17 = { class: "radio-group-label" }
const _hoisted_18 = { class: "radio-group-wrapper" }
const _hoisted_19 = { class: "radio-group-label" }
const _hoisted_20 = { class: "radio-group-wrapper" }
const _hoisted_21 = { class: "radio-group-label" }
const _hoisted_22 = { class: "radio-group-wrapper" }
const _hoisted_23 = { class: "radio-group-label" }
const _hoisted_24 = { class: "radio-group-wrapper" }
const _hoisted_25 = { class: "radio-group-label" }
const _hoisted_26 = { class: "radio-group-wrapper" }
const _hoisted_27 = { class: "radio-group-label" }
const _hoisted_28 = { class: "d-flex my-4" }
const _hoisted_29 = {
  key: 1,
  class: "my-4"
}
const _hoisted_30 = { class: "radio-group-wrapper" }
const _hoisted_31 = { class: "radio-group-label" }
const _hoisted_32 = { class: "radio-group-wrapper" }
const _hoisted_33 = { class: "radio-group-label" }
const _hoisted_34 = { class: "radio-group-wrapper" }
const _hoisted_35 = { class: "radio-group-label" }
const _hoisted_36 = { class: "radio-group-wrapper" }
const _hoisted_37 = { class: "radio-group-label" }
const _hoisted_38 = { class: "radio-group-wrapper" }
const _hoisted_39 = { class: "radio-group-label" }
const _hoisted_40 = { class: "radio-group-wrapper" }
const _hoisted_41 = { class: "radio-group-label" }
const _hoisted_42 = { class: "radio-group-wrapper" }
const _hoisted_43 = { class: "radio-group-label" }
const _hoisted_44 = { class: "radio-group-wrapper" }
const _hoisted_45 = { class: "radio-group-label" }
const _hoisted_46 = { class: "radio-group-wrapper" }
const _hoisted_47 = { class: "radio-group-label" }
const _hoisted_48 = { class: "radio-group-wrapper" }
const _hoisted_49 = { class: "radio-group-label" }
const _hoisted_50 = { class: "radio-group-wrapper" }
const _hoisted_51 = { class: "radio-group-label" }
const _hoisted_52 = { class: "radio-group-wrapper" }
const _hoisted_53 = { class: "radio-group-label" }
const _hoisted_54 = { class: "radio-group-wrapper" }
const _hoisted_55 = { class: "radio-group-label" }
const _hoisted_56 = { class: "d-flex my-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_date_time_picker = _resolveComponent("date-time-picker")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.isOpen,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.isOpen) = $event)),
      "max-width": "720"
    }, {
      default: _withCtx(() => [
        (_ctx.isOpen)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              class: "pa-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_page_title, {
                  value: _ctx.$t('foodMenu.inspection')
                }, null, 8, ["value"]),
                (_ctx.testingMeal.test)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('foodMenu.seasoning')), 1),
                        _createVNode(_component_v_radio_group, {
                          class: "radio-group",
                          modelValue: _ctx.testingMeal.test.flavor,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.testingMeal.test.flavor) = $event)),
                          inline: "",
                          "hide-details": "",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.appropriate'),
                              value: 1
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.sweet'),
                              value: 2
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.salty'),
                              value: 3
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('foodMenu.firmness')), 1),
                        _createVNode(_component_v_radio_group, {
                          class: "radio-group",
                          modelValue: _ctx.testingMeal.test.texture,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.testingMeal.test.texture) = $event)),
                          inline: "",
                          "hide-details": "",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.appropriate'),
                              value: 1
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.hard'),
                              value: 2
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.soft'),
                              value: 3
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('foodMenu.freshness')), 1),
                        _createVNode(_component_v_radio_group, {
                          class: "radio-group",
                          modelValue: _ctx.testingMeal.test.freshness,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.testingMeal.test.freshness) = $event)),
                          inline: "",
                          "hide-details": "",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.fresh'),
                              value: 1
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.good'),
                              value: 2
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.poor'),
                              value: 3
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('foodMenu.arrangement')), 1),
                        _createVNode(_component_v_radio_group, {
                          class: "radio-group",
                          modelValue: _ctx.testingMeal.test.arrangement,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.testingMeal.test.arrangement) = $event)),
                          inline: "",
                          "hide-details": "",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.beautiful'),
                              value: 1
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.normal'),
                              value: 2
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.poor'),
                              value: 3
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('foodMenu.color')), 1),
                        _createVNode(_component_v_radio_group, {
                          class: "radio-group",
                          modelValue: _ctx.testingMeal.test.color,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.testingMeal.test.color) = $event)),
                          inline: "",
                          "hide-details": "",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.beautiful'),
                              value: 1
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.normal'),
                              value: 2
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.poor'),
                              value: 3
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('foodMenu.quantity')), 1),
                        _createVNode(_component_v_radio_group, {
                          class: "radio-group",
                          modelValue: _ctx.testingMeal.test.quantity,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.testingMeal.test.quantity) = $event)),
                          inline: "",
                          "hide-details": "",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.appropriate'),
                              value: 1
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.more'),
                              value: 2
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.less'),
                              value: 3
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('foodMenu.foreignMatter')), 1),
                        _createVNode(_component_v_radio_group, {
                          class: "radio-group",
                          modelValue: _ctx.testingMeal.test.hasNoForeignMatter,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.testingMeal.test.hasNoForeignMatter) = $event)),
                          inline: "",
                          "hide-details": "",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.none'),
                              value: true
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.exists'),
                              value: false
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('foodMenu.heating')), 1),
                        _createVNode(_component_v_radio_group, {
                          class: "radio-group",
                          modelValue: _ctx.testingMeal.test.hasProperHeat,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.testingMeal.test.hasProperHeat) = $event)),
                          inline: "",
                          "hide-details": "",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.proper'),
                              value: true
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.improper'),
                              value: false
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('foodMenu.odor')), 1),
                        _createVNode(_component_v_radio_group, {
                          class: "radio-group",
                          modelValue: _ctx.testingMeal.test.hasNoOdor,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.testingMeal.test.hasNoOdor) = $event)),
                          inline: "",
                          "hide-details": "",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.none'),
                              value: true
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.exists'),
                              value: false
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('foodMenu.taste')), 1),
                        _createVNode(_component_v_radio_group, {
                          class: "radio-group",
                          modelValue: _ctx.testingMeal.test.hasProperTaste,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.testingMeal.test.hasProperTaste) = $event)),
                          inline: "",
                          "hide-details": "",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.none'),
                              value: true
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.exists'),
                              value: false
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('foodMenu.notes')), 1),
                        _createVNode(_component_v_textarea, {
                          modelValue: _ctx.testingMeal.test.note,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.testingMeal.test.note) = $event)),
                          variant: "outlined",
                          "hide-details": "",
                          color: "primary"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('foodMenu.testedBy')), 1),
                        _createVNode(_component_v_select, {
                          variant: "outlined",
                          items: _ctx.staffOptions,
                          "item-value": "userId",
                          "item-title": "name",
                          modelValue: _ctx.updatingTestedBy,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.updatingTestedBy) = $event)),
                          "hide-details": "",
                          color: "primary"
                        }, null, 8, ["items", "modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('foodMenu.testedAt')), 1),
                        _createVNode(_component_date_time_picker, {
                          modelValue: _ctx.updatingTestedAt,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.updatingTestedAt) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      (_ctx.isUpdating)
                        ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                            key: 0,
                            indeterminate: "",
                            class: "my-4",
                            color: "primary"
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          variant: "flat",
                          class: "mx-4",
                          size: "large",
                          disabled: _ctx.isUpdating,
                          onClick: _ctx.updateTest
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('foodMenu.updateTest')), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled", "onClick"]),
                        _createVNode(_component_v_spacer)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('foodMenu.seasoning')), 1),
                        _createVNode(_component_v_radio_group, {
                          class: "radio-group",
                          modelValue: _ctx.flavor,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.flavor) = $event)),
                          inline: "",
                          "hide-details": "",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.appropriate'),
                              value: 1
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.sweet'),
                              value: 2
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.salty'),
                              value: 3
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('foodMenu.firmness')), 1),
                        _createVNode(_component_v_radio_group, {
                          class: "radio-group",
                          modelValue: _ctx.texture,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.texture) = $event)),
                          inline: "",
                          "hide-details": "",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.appropriate'),
                              value: 1
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.hard'),
                              value: 2
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.soft'),
                              value: 3
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('foodMenu.freshness')), 1),
                        _createVNode(_component_v_radio_group, {
                          class: "radio-group",
                          modelValue: _ctx.freshness,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.freshness) = $event)),
                          inline: "",
                          "hide-details": "",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.fresh'),
                              value: 1
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.good'),
                              value: 2
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.poor'),
                              value: 3
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t('foodMenu.arrangement')), 1),
                        _createVNode(_component_v_radio_group, {
                          class: "radio-group",
                          modelValue: _ctx.arrangement,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.arrangement) = $event)),
                          inline: "",
                          "hide-details": "",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.beautiful'),
                              value: 1
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.normal'),
                              value: 2
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.poor'),
                              value: 3
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t('foodMenu.color')), 1),
                        _createVNode(_component_v_radio_group, {
                          class: "radio-group",
                          modelValue: _ctx.color,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.color) = $event)),
                          inline: "",
                          "hide-details": "",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.beautiful'),
                              value: 1
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.normal'),
                              value: 2
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.poor'),
                              value: 3
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t('foodMenu.quantity')), 1),
                        _createVNode(_component_v_radio_group, {
                          class: "radio-group",
                          modelValue: _ctx.quantity,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.quantity) = $event)),
                          inline: "",
                          "hide-details": "",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.appropriate'),
                              value: 1
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.more'),
                              value: 2
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.less'),
                              value: 3
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t('foodMenu.foreignMatter')), 1),
                        _createVNode(_component_v_radio_group, {
                          class: "radio-group",
                          modelValue: _ctx.hasNoForeignMatter,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.hasNoForeignMatter) = $event)),
                          inline: "",
                          "hide-details": "",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.none'),
                              value: true
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.exists'),
                              value: false
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.$t('foodMenu.heating')), 1),
                        _createVNode(_component_v_radio_group, {
                          class: "radio-group",
                          modelValue: _ctx.hasProperHeat,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.hasProperHeat) = $event)),
                          inline: "",
                          "hide-details": "",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.proper'),
                              value: true
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.improper'),
                              value: false
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$t('foodMenu.odor')), 1),
                        _createVNode(_component_v_radio_group, {
                          class: "radio-group",
                          modelValue: _ctx.hasNoOdor,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.hasNoOdor) = $event)),
                          inline: "",
                          "hide-details": "",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.none'),
                              value: true
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.exists'),
                              value: false
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('foodMenu.taste')), 1),
                        _createVNode(_component_v_radio_group, {
                          class: "radio-group",
                          modelValue: _ctx.hasProperTaste,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.hasProperTaste) = $event)),
                          inline: "",
                          "hide-details": "",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.none'),
                              value: true
                            }, null, 8, ["label"]),
                            _createVNode(_component_v_radio, {
                              label: _ctx.$t('foodMenu.exists'),
                              value: false
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.$t('foodMenu.notes')), 1),
                        _createVNode(_component_v_textarea, {
                          modelValue: _ctx.note,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.note) = $event)),
                          variant: "outlined",
                          "hide-details": "",
                          color: "primary"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.$t('foodMenu.testedBy')), 1),
                        _createVNode(_component_v_select, {
                          variant: "outlined",
                          items: _ctx.staffOptions,
                          "item-value": "userId",
                          "item-title": "name",
                          modelValue: _ctx.testedBy,
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.testedBy) = $event)),
                          "hide-details": "",
                          color: "primary"
                        }, null, 8, ["items", "modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.$t('foodMenu.testedAt')), 1),
                        _createVNode(_component_date_time_picker, {
                          modelValue: _ctx.testedAt,
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.testedAt) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      (_ctx.isCreating)
                        ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                            key: 0,
                            indeterminate: "",
                            class: "my-4",
                            color: "primary"
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_56, [
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          variant: "flat",
                          size: "large",
                          disabled: !_ctx.isCreationValid || _ctx.isCreating,
                          onClick: _ctx.createTest
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common_actions.createInspection')), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled", "onClick"]),
                        _createVNode(_component_v_spacer)
                      ])
                    ]))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}